import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eUXr1L2ENfAzbQbbbmot7u/ad3.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/7h1qPU2exeCiQA1AgFwB9M/5.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const results = [{
  label: 'TIENDA 1',
  amount: '$47.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: '$21.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: '$42.140.000',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroSlide, setHeroSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % results.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + results.length) % results.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % results.length);
  const goHeroPrev = () => setHeroSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goHeroNext = () => setHeroSlide(prev => (prev + 1) % resultImages.length);
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[10px] pb-[10px] mt-[0px] mb-[0px]" data-id="element-324" data-mp="216wrmd4i8z1w">
      <div className="max-w-6xl mx-auto pt-[0px] pb-[0px]" data-id="element-325" data-mp="25xd7s4zpmyry">
        <div className="text-center mb-12" data-id="element-326" data-mp="25yo8tx1rtsfd">
          
        </div>

        <div className="max-w-3xl mx-auto mt-8 mb-8" data-id="element-327" data-mp="1r9iccgubigb6">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl animate-neon-violet mt-[0px] mb-[0px] pt-[34px] pb-[34px]" data-id="element-328" data-mp="1r6mgcy2161pd">
            <h3 className="md:text-2xl text-white mb-2 font-[Montserrat,_sans-serif] text-[23px] font-[700]" data-id="element-329" data-mp="2jyfqc7rhxqy4">
              📈 Proyección de Ingresos: 5 Clientas Nuevas por Semana
            </h3>
            <p className="md:text-base text-[#D9D9D9] italic mb-6 text-[14px] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-330" data-mp="29y5fgtsxovm4">
              (Ingreso puro por primeras colocaciones, sin contabilizar futuros
              mantenimientos)
            </p>

            <div className="overflow-x-auto" data-id="element-331" data-mp="13imofuszg597">
              <table className="w-full text-left border-collapse" data-id="element-332" data-mp="13jo3ead4dbw7">
                <thead data-id="element-333" data-mp="3hq4abfqo4b2d">
                  <tr className="border-b border-[#FC9DFF]/30" data-id="element-334" data-mp="3hpcf460zgfcm">
                    <th className="py-3 pr-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-335" data-mp="3cs2io6f6f3fa">
                      Tipo de Espacio
                    </th>
                    <th className="py-3 px-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-336" data-mp="3mq082x8rv69h">
                      Valor 1ra Colocación (ARS)
                    </th>
                    <th className="py-3 pl-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-337" data-mp="2u1l4r7z06cdz">
                      Ingreso Mensual (4 semanas)
                    </th>
                  </tr>
                </thead>
                <tbody className="text-white text-[14px] md:text-base font-[Montserrat,_sans-serif]" data-id="element-338" data-mp="330gc4nds9siv">
                  <tr className="border-b border-[#FC9DFF]/15" data-id="element-339" data-mp="2fa2gkmvzpbjj">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-340" data-mp="2b9imjs6pqo1m">
                      🏠 <span className="font-bold" data-id="element-341" data-mp="2o0b3nijf1ayl">Home Studio</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-342" data-mp="2nxycqfvojq9e">
                        (Ideal principiantes)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-343" data-mp="2xx71muboueow">$35.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-344" data-mp="32p78l6q6e7uz">
                      $700.000 ARS
                    </td>
                  </tr>
                  <tr className="border-b border-[#FC9DFF]/15" data-id="element-345" data-mp="37niifhgh0id7">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-346" data-mp="3bolx40ms88cu">
                      💅 <span className="font-bold" data-id="element-347" data-mp="3goq3gxtz7mpc">Showroom / Estudio</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-348" data-mp="3gmngyns18bpd">
                        (Profesionales con experiencia)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-349" data-mp="1mbqrdeot1amt">$45.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-350" data-mp="1r90get8a7ka4">
                      $900.000 ARS
                    </td>
                  </tr>
                  <tr data-id="element-351" data-mp="1jrc2crtwz8jz">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-352" data-mp="1ezasfck7xtx4">
                      ✨ <span className="font-bold" data-id="element-353" data-mp="1exzqliac2w8n">Salón Premium</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-354" data-mp="1a0zil1txbjew">
                        (Estética de alto nivel)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-355" data-mp="22olm6a35io1r">$60.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-356" data-mp="22mspnnm95k7h">
                      $1.200.000 ARS
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>;
}